import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[thNumericValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NumericValidatorDirective,
      multi: true
    }
  ]
})
export class NumericValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value != null && isNaN(Number(control.value))) {
      return { numeric: true };
    } else {
      return null;
    }
  }
}
